import * as React from 'react';

function SvgChatSmile(props) {
  return (
    <svg fill="none" width={86} height={122} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g filter="url(#chat-smile_svg__a)">
        <path
          d="M86 77l-11.138-8.974H38.5c-.663 0-1.299-.27-1.768-.751A2.598 2.598 0 0136 65.46V29.565c0-.68.263-1.332.732-1.813A2.469 2.469 0 0138.5 27h45c.663 0 1.299.27 1.768.751.469.48.732 1.133.732 1.813V77z"
          fill="#38B2A6"
        />
        <path d="M72.607 46.643a12.5 12.5 0 11-25 0h5a7.5 7.5 0 0015 0h5z" fill="#fff" />
      </g>
      <defs>
        <filter
          id="chat-smile_svg__a"
          x={0}
          y={0}
          width={122}
          height={122}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius={8}
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_861_7093"
          />
          <feOffset dy={9} />
          <feGaussianBlur stdDeviation={14} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_861_7093" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={6} />
          <feGaussianBlur stdDeviation={8} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend in2="effect1_dropShadow_861_7093" result="effect2_dropShadow_861_7093" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius={4} in="SourceAlpha" result="effect3_dropShadow_861_7093" />
          <feOffset dy={3} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend in2="effect2_dropShadow_861_7093" result="effect3_dropShadow_861_7093" />
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_861_7093" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export default SvgChatSmile;
